// src/router/usuariosClientes.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']



const clientesBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Clientes',
        to: 'Clientes'
    }
]

export default [
    {
        path: '/usuarios/clientes',
        name: 'UsuariosClientes',
        component: () => import('@/views/Usuarios/Clientes/UsuarioClienteListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Clientes',
            breadcrumb: clientesBreadCrumb
        },
    },
    {
        path: '/usuarios/clientes/novo',
        name: 'UsuarioClienteNovo',
        component: () => import('@/views/Usuarios/Clientes/NovoUsuarioClientePage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Cliente',
            breadcrumb: [
                ...clientesBreadCrumb,
                {
                    label: 'Novo Cliente',
                    to: 'ClienteNovo'
                }
            ]
        }
    },
    {
        path: '/usuarios/clientes/:id/edit',
        name: 'UsuarioClienteEdit',
        component: () => import('@/views/Usuarios/Clientes/NovoUsuarioClientePage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Cliente',
            breadcrumb: [
                ...clientesBreadCrumb,
                {
                    label: 'Novo Cliente',
                    to: 'ClienteNovo'
                }
            ]
        }
    }
];
